import clsx from 'clsx'
import {useFormik} from 'formik'
import React from 'react'
import {Button, Modal} from 'react-bootstrap'
import * as Yup from 'yup'
import HelpBubble from '../utils/HelpBubble'

const titleSchama = Yup.object().shape({
  title: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(100, 'Maximum 100 symbols')
    .required('This field is required'),
})

const initialValues = {
  title: 'Full stack engineer',
}
type Props = {
  editModal: boolean
  handleEditModal: () => void
}

function TitleModal({editModal, handleEditModal}: Props) {
  const formik = useFormik({
    initialValues,
    validationSchema: titleSchama,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      try {
        //call action here
      } catch (error) {
        console.error(error)
      }
    },
  })
  return (
    <Modal show={editModal} onHide={handleEditModal} size={'lg'}>
      <Modal.Header closeButton>
        <Modal.Title>Edit your title</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={formik.handleSubmit} noValidate>
          <div className='py-4'>
            <HelpBubble
              icon='/media/icons/duotune/general/gen045.svg'
              text='Enter a single sentence description of your professional skills/experience'
            />
          </div>
          <div>
            <div className='fv-row mb-10'>
              <input
                {...formik.getFieldProps('title')}
                placeholder='your title'
                className={clsx(
                  'form-control form-control-lg form-control-solid',
                  {'is-invalid': formik.touched.title && formik.errors.title},
                  {
                    'is-valid': formik.touched.title && !formik.errors.title,
                  }
                )}
                type='text'
                name='title'
                autoComplete='off'
              />
              {formik.touched.title && formik.errors.title && (
                <div className='fv-plugins-message-container'>
                  <span role='alert'>{formik.errors.title}</span>
                </div>
              )}
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={handleEditModal}>
          Close
        </Button>
        <Button type='submit' disabled={formik.isSubmitting || !formik.isValid} variant='primary'>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default TitleModal
